import React from 'react'
import logoFirmament from '../../assets/icons/logoFirmament.svg'
import { Container } from './styles'

export const FirmamentGlobalLogo: React.FC = () => {
  return (
    <Container>
      <img src={logoFirmament} alt="" />
    </Container>
  )
}
